import { PHASE_PRODUCTION_BUILD } from 'next/constants';

export const getBackendUrl = () => {
  if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
    return process.env.NEXT_PUBLIC_BACKEND_URL ?? '';
  } else {
    return typeof window === 'undefined'
      ? (process.env.NEXT_PUBLIC_BACKEND_INTERNAL_URL ?? '')
      : (process.env.NEXT_PUBLIC_BACKEND_URL ?? '');
  }
};
